import { Task } from '../../pm/types';

interface Props {
  tasks: Task[];
}

const StatCards: React.FC<Props> = ({ tasks }) => {
  const total = tasks.length;
  const inProgress = tasks.filter((t) => t.status === 'progress').length;
  const done = tasks.filter((t) => t.status === 'done').length;
  const blocked = tasks.filter((t) => t.status === 'blocked').length;

  const items: Array<{ label: string; value: number }> = [
    { label: 'Total', value: total },
    { label: 'In progress', value: inProgress },
    { label: 'Done', value: done },
    { label: 'Blocked', value: blocked },
  ];

  return (
    <div className="pm-stat-cards">
      {items.map((it) => (
        <div className="pm-stat-card" key={it.label}>
          <div className="pm-stat-label">{it.label}</div>
          <div className="pm-stat-value">{it.value}</div>
        </div>
      ))}
    </div>
  );
};

export default StatCards;
